export default {
      id: "logo-helicopters-usage",
      viewBox: "0 0 233.6 27.07",
      url: __webpack_public_path__ + "img/icons.507a1d9d.svg#logo-helicopters",
      toString: function () {
        return this.url;
      }
    }